/**
  Intro:

  The master frontend app class wrapping all the constituent children routes and
  components for display - hook all events to apply on the application level
  here

  Usage:  ----------------------------------------------------------------------

    import SoompiApp from 'scripts/lib/SoompiApp'

    ReactDOM.render(
      <BrowserRouter>
        <SoompiApp>
          {children-element-here}
        </SoompiApp>
      </BrowserRouter
    , htmlDOMNode)

  ------------------------------------------------------------------------------=
**/

import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { renderRoutes } from 'scripts/helpers/Renderer'
import { routes } from 'scripts/routes'
import Navigation from 'scripts/components/navigations/Navigation'
import FeatureFlags from 'scripts/components/static/feature_flags'
import Feedback from 'scripts/components/static/feedback'
import CookieBanner from 'scripts/components/static/CookieBanner'
import ErrorPrompt from 'scripts/components/errorLog/ErrorPrompt'
import { renderDarkMode } from 'scripts/lib/utils'
import SsrContext from 'scripts/components/base/SsrContext'

const TIME_TO_REFRESH_SECONDS = 3600 // Force reload every 1 hour

class SoompiApp extends Component {
  constructor(props) {
    super(props)
    const mountNode = document.getElementById('app')
    // Client side app config initialisation
    this.state = {
      appConfig: window[mountNode.dataset.appConfig],
      timestamp: this.getTSWindow(), // get the timestamp
      reload: false
    }
  }

  getTSWindow() {
    return Math.ceil(new Date() / 1000)
  }

  componentDidMount() {
    renderDarkMode()
  }

  componentDidCatch(error, info) {
    if (error && info) {
      ErrorPrompt.notify(error, {
        message: error.toString(),
        context: info
      })
    }
  }

  componentWillReceiveProps() {
    // Check if the time stamp is over the threshold
    // if so then reload then set state reload to true
    if (this.getTSWindow() - this.state.timestamp > TIME_TO_REFRESH_SECONDS) {
      this.setState({reload: true})
    }
  }

  render() {
    // Check if reload is set to true
    // then force reload the page whatever page it is
    if (this.state.reload) {
      window.location.reload()
      return null
    }
    const { children } = this.props
    const relayedProps = { appConfig: this.state.appConfig, locale: this.props.locale }
    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child, relayedProps)
    )
    return (
      <React.Fragment>
        <Navigation {...this.props} />
        <SsrContext.Provider value={{ssr: false}}>
          {renderRoutes(routes, relayedProps)}
        </SsrContext.Provider>
        <CookieBanner {...this.props} />
        <Feedback {...this.props} />
        <FeatureFlags {...relayedProps} />
        {childrenWithProps}
      </React.Fragment>
    )
  }
}

export default withRouter(SoompiApp)



// WEBPACK FOOTER //
// ./assets/js/components/SoompiApp.jsx